// extracted by mini-css-extract-plugin
module.exports = {"formy":"form_formy__142rU"};